import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select", "hint"]

  async clientChanged(event) {
    if (!this.hasSelectTarget) return
    if (this.selectTarget.dataset.frozen === "true") return

    const clientId = event.target.value
    if (!clientId) return this.unlock()

    const response = await fetch(`/clients/${clientId}/build.json`, {
      headers:     { Accept: "application/json" },
      credentials: "same-origin"
    })
    if (!response.ok) return

    const client = await response.json()
    client.partner ? this.lock(client.partner) : this.unlock()
  }

  lock(partner) {
    this.selectTarget.value    = partner.id
    this.selectTarget.disabled = true
    this.hintTarget.hidden     = false
  }

  unlock() {
    this.selectTarget.disabled = false
    this.hintTarget.hidden     = true
  }
}
